"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.allEpics = void 0;
const ro = require("redux-observable");
const details = require("./details");
const list_1 = require("./list");
const projects_1 = require("./projects");
exports.allEpics = ro.combineEpics(
// DETAILS
details.fetch, details.revert, 
// List
list_1.fetchActivities, list_1.fetchActivityTypes, 
// Projects
projects_1.fetchProjects);
//# sourceMappingURL=index.js.map